<lepi-fieldset [label]="label()" [required]="required() ? 'true' : 'false'">
  <div class="flex gap-3 items-center">
    <lepi-date-picker [(value)]="startAt" (valueChange)="handleChange()" />
    <p class="mt-1">-</p>
    <lepi-date-picker [(value)]="endAt" (valueChange)="handleChange()" />
  </div>
</lepi-fieldset>
